/**
 * "You might like" — local-catalog-first subject/genre overlap scoring.
 * Open Library subject search (services/openLibraryService.js's
 * searchBySubject) is the fallback when there aren't enough local matches,
 * wired up in hooks/useSimilarBooks.js.
 */

import { getAllCatalogBooks } from '@/lib/localBookCatalog';
import { getCanonicalBookId } from '@/lib/bookModel';

function tagsOf(book) {
  return (book.subjects ?? book.genres ?? []).map((s) => s.toLowerCase());
}

function overlapScore(selfTags, candidate) {
  const candidateTags = tagsOf(candidate);
  return candidateTags.filter((t) => selfTags.has(t)).length;
}

export function getSimilarBooks(book, { limit = 8 } = {}) {
  if (!book) return [];
  const selfId = getCanonicalBookId(book);
  const selfTags = new Set(tagsOf(book));
  if (selfTags.size === 0) return [];

  return getAllCatalogBooks()
    .filter((candidate) => candidate.id !== selfId)
    .map((candidate) => ({ candidate, score: overlapScore(selfTags, candidate) }))
    .filter(({ score }) => score > 0)
    .sort((a, b) => (b.score - a.score) || ((b.candidate.friendsReading ?? 0) - (a.candidate.friendsReading ?? 0)))
    .slice(0, limit)
    .map(({ candidate }) => candidate);
}
